import { hostedAuthSession } from '@unipile/db';
import { createInsertSchema } from 'drizzle-typebox';

export const InsertHostedAuthSessionSchema = createInsertSchema(hostedAuthSession);

export type HostedAuthSession = typeof hostedAuthSession.$inferSelect;
export type InsertHostedAuthSession = typeof hostedAuthSession.$inferInsert;
